var r = /* @__PURE__ */ ((h) => (h.H1 = "h1", h.H2 = "h2", h.H3 = "h3", h.H4 = "h4", h))(r || {});
export {
  r as MsHeadlineType
};
